/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultYookassaMerchantData
 */
export interface FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultYookassaMerchantData {
    /**
     * 
     * @type {boolean}
     * @memberof FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultYookassaMerchantData
     */
    Redirect: boolean;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultYookassaMerchantData
     */
    ConfirmationUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultYookassaMerchantData
     */
    ConfirmationToken?: string | null;
}

/**
 * Check if a given object implements the FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultYookassaMerchantData interface.
 */
export function instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultYookassaMerchantData(value: object): value is FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultYookassaMerchantData {
    if (!('Redirect' in value) || value['Redirect'] === undefined) return false;
    return true;
}

export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultYookassaMerchantDataFromJSON(json: any): FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultYookassaMerchantData {
    return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultYookassaMerchantDataFromJSONTyped(json, false);
}

export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultYookassaMerchantDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultYookassaMerchantData {
    if (json == null) {
        return json;
    }
    return {
        
        'Redirect': json['Redirect'],
        'ConfirmationUrl': json['ConfirmationUrl'] == null ? undefined : json['ConfirmationUrl'],
        'ConfirmationToken': json['ConfirmationToken'] == null ? undefined : json['ConfirmationToken'],
    };
}

export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultYookassaMerchantDataToJSON(json: any): FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultYookassaMerchantData {
    return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultYookassaMerchantDataToJSONTyped(json, false);
}

export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultYookassaMerchantDataToJSONTyped(value?: FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultYookassaMerchantData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Redirect': value['Redirect'],
        'ConfirmationUrl': value['ConfirmationUrl'],
        'ConfirmationToken': value['ConfirmationToken'],
    };
}

